import { useLookup } from "@ofqual/portal-core/core/hooks";
import { useSelector } from "react-redux";
import { ActionTypeCode } from "../domain/InformationRequestAction";
import {
  actionsSelector,
  itemSelector,
  recipientsSelector,
} from "../redux/selectors";
import {
  actionTypesService,
  cachedActionTypesService,
  cachedRequestTypeLookupService,
} from "../services";

const B4_REQUEST_TYPE_CODE = "InfNot";

export const useValidation = () => {
  const actionsState = useSelector(actionsSelector);
  const itemState = useSelector(itemSelector);
  const recipientsState = useSelector(recipientsSelector);

  const [requestTypeLookups, actionsLookups] = useLookup(
    cachedRequestTypeLookupService,
    cachedActionTypesService
  );
  const getRequestCode = (requestType: number | null) =>
    requestTypeLookups.find((x) => x.id === requestType)?.code;

  const getActionCode = (actionId: number): ActionTypeCode =>
    actionsLookups.find((x) => x.id === actionId)?.code;

  const isReady =
    actionsState.status === "LOADED" &&
    itemState.status === "LOADED" &&
    recipientsState.status === "LOADED";

  const isFormOk = !!(
    itemState.item &&
    itemState.item.requestType &&
    itemState.item.subject &&
    itemState.item.message
  );

  const isRecipientsOk = !!(
    recipientsState.recipients && recipientsState.recipients.length
  );

  const isActionsOk = !(
    itemState.item &&
    actionsState.actions &&
    getRequestCode(itemState.item.requestType) === B4_REQUEST_TYPE_CODE &&
    !actionsState.actions.some(
      (action) =>
        getActionCode(action.actionType) === ActionTypeCode.ReadDocument
    )
  );

  return {
    isReady,
    isFormOk,
    isRecipientsOk,
    isActionsOk,
    isOk: isFormOk && isRecipientsOk && isActionsOk,
  };
};
